const getUserName = () => {
  return localStorage.getItem('bn_user') || 'user not found';
};

export default getUserName;
